import z from 'zod';
import {AccountTierSchema} from './scoredAccounts';

export const AccountTierAndSegmentSchema = z.object({
  domain: z.string(),
  fitScore: z.number(),
  tier: AccountTierSchema,
  tierReasoning: z.string(),
  segment: z.string(),
  segmentReasoning: z.string(),
});
export type AccountTierAndSegment = z.infer<typeof AccountTierAndSegmentSchema>;
